import {
  Checkbox,
  FormControl,
  FormControlLabel,
  Grid,
  InputAdornment,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import { Controller } from "react-hook-form";

interface OrderInputProps {
  control: any;
  errors: any;
  disabled: any;
}

export const FirstNameInput = (props: OrderInputProps) => {
  const { control, errors, disabled } = props;
  return (
    <Grid container rowGap={1}>
      <Typography fontSize={"13px"}> First Name</Typography>
      <Controller
        name="first_name"
        control={control}
        render={({ field }) => (
          <TextField
            {...field}
            fullWidth
            size="small"
            disabled={disabled}
            placeholder="Fist Name"
            error={errors.first_name ? true : false}
            helperText={errors.first_name?.message}
            variant="outlined"
          />
        )}
      />
    </Grid>
  );
};

export const LastNameInput = (props: OrderInputProps) => {
  const { control, errors, disabled } = props;
  return (
    <Grid container rowGap={1}>
      <Typography fontSize={"13px"}> Last Name</Typography>
      <Controller
        name="last_name"
        control={control}
        render={({ field }) => (
          <TextField
            {...field}
            fullWidth
            size="small"
            disabled={disabled}
            placeholder="Last Name"
            error={errors.last_name ? true : false}
            helperText={errors.last_name?.message}
            variant="outlined"
          />
        )}
      />
    </Grid>
  );
};

export const EmailInput = (props: OrderInputProps) => {
  const { control, errors, disabled } = props;
  return (
    <Grid container rowGap={1}>
      <Typography fontSize={"13px"}> Email</Typography>
      <Controller
        name="email"
        control={control}
        render={({ field }) => (
          <TextField
            {...field}
            fullWidth
            size="small"
            disabled={disabled}
            placeholder="example@gmail.com"
            error={errors.email ? true : false}
            helperText={errors.email?.message}
            variant="outlined"
          />
        )}
      />
    </Grid>
  );
};

export const QuantityInput = (props: OrderInputProps) => {
  const { control, errors, disabled } = props;
  return (
    <Grid container rowGap={1}>
      <Typography fontSize={"13px"}>Quantity</Typography>
      <Controller
        name="quantity"
        control={control}
        render={({ field }) => (
          <TextField
            {...field}
            fullWidth
            size="small"
            disabled={disabled}
            error={errors.quantity ? true : false}
            helperText={errors.quantity?.message}
            variant="outlined"
            type="number"
            placeholder="20"
          />
        )}
      />
    </Grid>
  );
};

interface PaidInputProps extends OrderInputProps {
  setGuestPaid: any;
}

export const PaidInput = (props: PaidInputProps) => {
  const { control, setGuestPaid, errors, disabled } = props;
  return (
    <Grid container rowGap={1}>
      <Controller
        name="paid"
        control={control}
        render={({ field }) => (
          <FormControl {...field} fullWidth>
            <FormControlLabel
              control={
                <Checkbox
                  onChange={(event: any) => {
                    field.onChange(event.target.value);
                    setGuestPaid((prev: any) => !prev);
                  }}
                />
              }
              disabled={disabled}
              label="Paid for ticket"
            />
          </FormControl>
        )}
      />
    </Grid>
  );
};

export const PaymentTypeInput = (props: OrderInputProps) => {
  const { control, errors, disabled } = props;
  const paymentTypes = [
    { label: "Venmo", value: "venmo" },
    { label: "Zelle", value: "zelle" },
  ];
  return (
    <Grid container rowGap={1}>
      <Typography fontSize={"13px"}> Payment Method</Typography>
      <Controller
        name="payment_type"
        control={control}
        render={({ field }) => (
          <Select
            {...field}
            fullWidth
            size="small"
            placeholder="venmo"
            disabled={disabled}
            error={errors.payment_type ? true : false}
            variant="outlined"
            onChange={(event: any) => {
              field.onChange(event.target.value.toString());
            }}
          >
            {paymentTypes.map((payment) => (
              <MenuItem key={payment.label} value={payment.value}>
                <Typography>{payment.label}</Typography>
              </MenuItem>
            ))}
          </Select>
        )}
      />
    </Grid>
  );
};

export const PriceInput = (props: OrderInputProps) => {
  const { control, errors, disabled } = props;
  return (
    <Grid container rowGap={0.5}>
      <Typography color={"var(--cuo-text-muted)"} fontSize={"13px"}>
        Price
      </Typography>
      <Controller
        name="price"
        control={control}
        render={({ field }) => (
          <TextField
            {...field}
            fullWidth
            size="small"
            disabled={disabled}
            placeholder="100"
            error={errors.ticket_price ? true : false}
            helperText={errors.ticket_price?.message}
            variant="outlined"
            type="number"
            inputProps={{
              min: 0,
              max: 500,
              step: 0.01,
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">$</InputAdornment>
              ),
            }}
          />
        )}
      />
    </Grid>
  );
};

export const NotesInput = (props: OrderInputProps) => {
  const { control, errors, disabled } = props;
  return (
    <Grid container rowGap={1}>
      <Typography fontSize={"13px"}> Notes</Typography>
      <Controller
        name="notes"
        control={control}
        render={({ field }) => (
          <TextField
            fullWidth
            {...field}
            disabled={disabled}
            error={errors.notes ? true : false}
            helperText={errors.notes?.message}
            variant="outlined"
            multiline
            rows={3}
          />
        )}
      />
    </Grid>
  );
};
